// extracted by mini-css-extract-plugin
export default {"error_message":"UserGamePage_error_message__9DQsb"};